(function () {
  'use strict';

  function initSection(section) {
    if (!section || !section.hasAttribute('data-testimonials-section')) return;

    const swiperElement = section.querySelector('[data-testimonials-swiper]');
    const paginationBars = section.querySelectorAll('[data-pagination-index]');

    let swiperInstance = null;
    let wheelListenerAdded = false;
    let lastWheelSlideTime = 0;
    const WHEEL_COOLDOWN_MS = 400;

    function destroySwiper() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    function initSwiper() {
      if (!swiperElement || typeof Swiper === 'undefined') {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
        }
        return;
      }

      destroySwiper();

      swiperInstance = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        speed: 300,
        allowTouchMove: true,
        on: {
          init: function () {
            updatePagination(this.activeIndex);
            updateSlideBackground(this.activeIndex);
            if (!wheelListenerAdded && swiperElement) {
              wheelListenerAdded = true;
              swiperElement.addEventListener(
                'wheel',
                function (e) {
                  if (!swiperInstance) return;
                  const isHorizontal = Math.abs(e.deltaX) > Math.abs(e.deltaY);
                  if (!isHorizontal) return;
                  e.preventDefault();
                  const threshold = 15;
                  if (Math.abs(e.deltaX) < threshold) return;
                  const now = Date.now();
                  if (now - lastWheelSlideTime < WHEEL_COOLDOWN_MS) return;
                  lastWheelSlideTime = now;
                  if (e.deltaX > 0) {
                    if (!swiperInstance.isEnd) swiperInstance.slideNext();
                  } else {
                    if (!swiperInstance.isBeginning) swiperInstance.slidePrev();
                  }
                },
                { passive: false },
              );
            }
          },
          slideChange: function () {
            updatePagination(this.activeIndex);
            updateSlideBackground(this.activeIndex);
          },
        },
      });
    }

    function updatePagination(activeIndex) {
      paginationBars.forEach(function (bar, index) {
        const isActive = index === activeIndex;
        bar.classList.toggle('testimonials__pagination-bar--active', isActive);
        bar.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function loadSlideBackgroundImages(slideEl) {
      if (!slideEl) return;
      slideEl.querySelectorAll('img[data-src]').forEach(function (img) {
        const src = img.getAttribute('data-src');
        const srcset = img.getAttribute('data-srcset');
        const picture = img.closest('picture');
        if (src) {
          img.src = src;
          img.removeAttribute('data-src');
        }
        if (srcset) {
          img.srcset = srcset;
          img.removeAttribute('data-srcset');
          if (picture) {
            const source = picture.querySelector('source');
            if (source) {
              source.srcset = srcset;
              source.removeAttribute('data-srcset');
            }
          }
        }
      });
    }

    function updateSlideBackground(activeIndex) {
      const container = section.querySelector('[data-testimonials-slide-backgrounds]');
      if (!container) return;
      container.querySelectorAll('[data-slide-index]').forEach(function (el) {
        const index = parseInt(el.getAttribute('data-slide-index'), 10);
        const isActive = index === activeIndex;
        el.classList.toggle('testimonials__slide-bg--active', isActive);
        if (isActive) {
          loadSlideBackgroundImages(el);
        }
      });
    }

    initSwiper();

    var container = section.querySelector('[data-testimonials-slide-backgrounds]');
    if (container) {
      var firstSlide = container.querySelector('[data-slide-index="0"]');
      if (firstSlide) {
        loadSlideBackgroundImages(firstSlide);
      }
    }
    if (swiperInstance) {
      updateSlideBackground(swiperInstance.activeIndex);
    }

    paginationBars.forEach(function (bar, index) {
      bar.addEventListener('click', function () {
        if (swiperInstance) {
          swiperInstance.slideTo(index);
          updatePagination(index);
          updateSlideBackground(index);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-testimonials-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = document.querySelector(
      '[data-testimonials-section][data-section-id="' + e.detail.sectionId + '"]',
    );
    if (section) {
      initSection(section);
    }
  });
})();
